import { render, staticRenderFns } from "./changePassWords.vue?vue&type=template&id=521b1a28&scoped=true&"
import script from "./changePassWords.vue?vue&type=script&lang=js&"
export * from "./changePassWords.vue?vue&type=script&lang=js&"
import style0 from "./changePassWords.vue?vue&type=style&index=0&id=521b1a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b1a28",
  null
  
)

export default component.exports